import React from 'react';
import ImageSlider from '../../components/imageslider';
import image from 'assets/images/que-es-incluir.png';

export default function Incluir() {
  return (
    <div className="wrapper">
      <div className="content-cols">
        <section>
          <h3>¿Qué es INCLUIR?</h3>
          <p>Es el programa de inclusión y educación financiera de Banco Provincia, con la participación de Grupo Provincia, Provincia Servicios Financieros, Provincia Microcréditos y la Fundación Banco Provincia.</p>
          <p>Su objetivo es promover y consolidar el acceso de la población bonaerense a los productos y servicios financieros esenciales; y educar a las personas en alternativas más sofisticadas, brindándoles las habilidades necesarias para que puedan utilizarlas.</p>
        </section>
        <figure>
          <img src={image} alt="¿Qué es INCLUIR?" />
        </figure>
      </div>
      <blockquote>Te invitamos a conocer nuestros proyectos, las experiencias en las distintas localidades de la Provincia y a aprender
de una manera cercana, fácil y divertida.</blockquote>
      <ImageSlider galeria="incluir" />
    </div>
  );
}
